import {Component, Input, OnInit} from '@angular/core';

import {TokenStorageService} from "../../services/storage/token-storage.service";

@Component({
    selector: 'app-landing-page',
    templateUrl: './landing-page.component.html',
    styleUrls: ['./landing-page.component.css'],
    standalone: false
})
export class LandingPageComponent implements OnInit {
  @Input() selectedApi: string = '';
  @Input() showOpen: boolean = false;
  @Input() showFix: boolean = false;
  @Input() showBackOffice: boolean = false;

  show = false;
  showTrade = false;
  showAllManageItems = false;
  showAllMarketItems = false;


  constructor(private tokenStorageService: TokenStorageService) {
    this.show = !!this.tokenStorageService.getToken();
    this.showTrade = this.tokenStorageService.getUserType() == 'OMS';
  }
  ngOnInit(): void {

  }

  onManageAllPress(event: Event) {
    event.preventDefault();
    this.showAllManageItems = !this.showAllManageItems;
  }

  onMarketAllPress(event: Event) {
    event.preventDefault();
    this.showAllMarketItems = !this.showAllMarketItems;
  }

}
